import React from 'react'
import { FiMoreVertical } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { ListItem } from '@material-ui/core'
import { withRouter } from 'react-router'
import { Desktop, Mobile } from '../../../components/MediaQuery'
import Header, { MenuLinkItem } from '../../../components/Template/Header'
import { AccountOptions, LanguageSwitcher, MobileDatePicker, Notifications, Search, ToggleMenu } from './Menu'
import Premium from './Menu/Premium'
import Sidebar from './Sidebar'
import { AccountMenu, LanguageMenu, NotificationsMenu, PremiumMenu, ReservationList, TaskMenu } from './Sidebar/Items'
import Home from './Menu/Home'
import Synchronization from './Synchronization'
import useIsScope from '../../../hooks/useIsScope'
import { PermissionScope } from '../../Employees'

const DeveloperTools = React.lazy(() => import('./Menu/DeveloperTools') as any)

function HeaderContainer({
  isSidebarOpen,
  toggleSidebar,
  size = 1,
  location,
}: any) {
  const [open, setOpen] = React.useState(false)

  function toggleOpen() {
    setOpen(!open)
  }

  function openSidebarMenu() {
    setOpen(true)
    if (toggleSidebar) {
      toggleSidebar(false)
    }
  }

  function toggle() {
    if (toggleSidebar) {
      toggleSidebar(!isSidebarOpen)
    }
  }

  function isCalendarLocation(): boolean {
    return (
      location &&
      (location.pathname === '/' ||
        location.pathname.includes('/booking/calendar'))
    )
  }


  const scopes = useIsScope({
    search: [PermissionScope.SCOPE_CAN_USE_SEARCH],
    reservationList: [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS],
    tasks: [
      [
        PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING,
        PermissionScope.SCOPE_CAN_USE_TASKS_FOOD,
        PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS,
        PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING,
      ],
    ],
  })

  return (
    <Header size={size} isSidebarOpen={isSidebarOpen}>
      <Flex justifyStart={true} style={{ height: '100%' }}>
        <ToggleMenu
          size={size}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggle}
          className={'navigation-menu-button-toggle'}
        />
        {scopes.search && <Search size={size} />}
        <Synchronization size={size} />
        <Desktop>
          <Home size={size} className={'navigation-menu-button-home'} />
        </Desktop>
        {isCalendarLocation() && (
          <Mobile>
            <MobileDatePicker />
          </Mobile>
        )}
        {/*{isPriceGridLocation() && (*/}
        {/*  <Mobile>*/}
        {/*    <MobileGridPriceDatePicker minDate={minDate} maxDate={maxDate} />*/}
        {/*  </Mobile>*/}
        {/*)}*/}
      </Flex>
      <Desktop>
        <Flex justifyEnd={true} style={{ height: '100%' }}>
          {process.env.NODE_ENV === 'development' && (
            <React.Suspense fallback={<div />}>
              <DeveloperTools />
            </React.Suspense>
          )}
          <Premium size={size} />
          <LanguageSwitcher
            size={size}
            className={'navigation-menu-language'}
          />
          <Notifications size={size} />
          <AccountOptions
            size={size}
            className={'navigation-menu-account-options'}
          />
        </Flex>
      </Desktop>
      <Mobile>
        <MenuLinkItem
          style={{ padding: '0 0.6em' }}
          center={true}
          onClick={openSidebarMenu}
        >
          <FiMoreVertical size={21} />
        </MenuLinkItem>
        <Sidebar open={open} closeDrawer={toggleOpen} scrollable={true}>
          <PremiumMenu toggleMenu={toggleOpen} />
          {scopes.tasks && <TaskMenu />}
          {scopes.reservationList && <ReservationList />}
          <NotificationsMenu />
          <AccountMenu />
          <ListItem
            style={{
              maxHeight: '60px',
              minHeight: '60px',
              minWidth: '30px',
              pointerEvents: 'none',
            }}
          />
          <LanguageMenu />
        </Sidebar>
      </Mobile>
    </Header>
  )
}

export default withRouter(HeaderContainer)

export interface IHeaderProps {
  isSidebarOpen: boolean
}

export interface IHeaderDispatch {
  toggleSidebar: (toggle?: boolean) => void
}
